import { RefObject, createRef } from 'react'

type PhotoUploadProps = {
    disabled?: boolean
    setPhoto: (f: File) => void
}

type PhotoUploadReturnType = [RefObject<HTMLInputElement>, () => void, () => void]

export const usePhotoUpload = ({ disabled, setPhoto }: PhotoUploadProps): PhotoUploadReturnType => {
    const addPhotoRef = createRef<HTMLInputElement>()

    const selectPhoto = () => {
        if (disabled ?? false) return

        if (addPhotoRef.current) {
            addPhotoRef.current.value = ''
            addPhotoRef.current.click()
        }
    }

    const selectedPhoto = () => {
        if (!addPhotoRef.current) return
        if (addPhotoRef.current.files && addPhotoRef.current.files.length > 0) {
            setPhoto(addPhotoRef.current.files[0])
        }
    }

    return [addPhotoRef, selectPhoto, selectedPhoto]
}
